import { GetAnnouncementRecipientsResponse } from '@/api/communication/get-announcement-recipients'
import { AnnouncementRecipientStatus } from '@/models/features'

export type AnnouncementRecipientCounts = Partial<
  Record<AnnouncementRecipientStatus | 'All', number>
>

// Status tab badges straight from the table's own response: the BE counters ignore the status
// filter, so every tab gets its total from whichever tab is selected. `count` is "All".
export const getAnnouncementRecipientCounts = (
  data: GetAnnouncementRecipientsResponse | undefined,
): AnnouncementRecipientCounts => (data ? { All: data.count, ...data.statusCounts } : {})

// Pagination total for the selected tab. BE `count` ignores the status filter, so it is only the
// right total on "All".
export const getAnnouncementRecipientsTotal = (
  counts: AnnouncementRecipientCounts,
  status: string | undefined,
): number => counts[(status || 'All') as keyof AnnouncementRecipientCounts] ?? 0
